export const DEFAULT_DATA_LAYER_NAME = 'dataLayer';
export const DEFAULT_GTM_SRC = 'https://www.googletagmanager.com/gtm.js';
export const GTM_NO_SCRIPT_URL = 'https://www.googletagmanager.com/ns.html';
